// extracted by mini-css-extract-plugin
module.exports = {"button":"SubmitButton_button__3B3av","purple":"SubmitButton_purple__30j66","buttonOutlined":"SubmitButton_buttonOutlined__XT73o","oo_tab":"SubmitButton_oo_tab__Yq6hR"};